import { FC } from 'react';
import { SvgIconProps } from '@mui/material';
import colors from '@styles/colors.module.scss';
import { Icon } from '@components/Icon';

export const RightArrowIcon: FC<SvgIconProps> = (props) => {
  return <Icon {...props} name="chevronRight" htmlColor={colors.black} />;
};
